var SelectedArray = "PinginGoVoucher";
var SelectedIDVoucherType = 1;
var CurrentStatusSort = "All";
var CurrentFunctionURL = "";

var CurrentVoucherIndex = 1;
var MaximumPageVoucher = 0;
var MaximumRewardToInstantiate = 6;

var RewardListData = [];

var ListOfTopSortType =
[
    {
        "What_Type": "PinginGoVoucher",
        "Function_Name": "/vouchers/in-app",
        "Name_Display":
        {
            "id":"Voucher PinginGo",
            "en":"PinginGo Voucher",
        }
    },
    {
        "What_Type": "VoucherPartner",
        "Function_Name": "/vouchers/partner",
        "Name_Display":
        {
            "id":"Voucher Partner",
            "en":"Partner Voucher",
        }
    },
    {
        "What_Type": "GiftReward",
        "Function_Name": "/vouchers/gift",
        "Name_Display":
        {
            "id":"Reward",
            "en":"Reward",
        }
    },
]

var ListOfStatusFilter =
[
    {
        "Sort_Type": "All",
        "Class_Name": "All",
        "Name_Display":
        {
            "id":"Semua Voucher",
            "idAbv":"Semua",
            "en":"All Voucher",
            "enAbv":"All",
        }
    },
    {
        "Sort_Type": "Available",
        "Class_Name": "Available",
        "Name_Display":
        {
            "id":"Voucher Tersedia",
            "idAbv":"Tersedia",
            "en":"Available Voucher",
            "enAbv":"Available",
        }
    },
    {
        "Sort_Type": "Expired",
        "Class_Name": "Expired",
        "Name_Display":
        {
            "id":"Voucher Kadaluwarsa",
            "idAbv":"Kadaluwarsa",
            "en":"Expired Voucher",
            "enAbv":"Expired",
        }
    },
    {
        "Sort_Type": "Used",
        "Class_Name": "Used",
        "Name_Display":
        {
            "id":"Voucher Terpakai",
            "idAbv":"Terpakai",
            "en":"Used Voucher",
            "enAbv":"Used",
        }
    },
    {
        "Sort_Type": "In Process",
        "Class_Name": "InProcess",
        "Name_Display":
        {
            "id":"Sedang Diproses",
            "idAbv":"Diproses",
            "en":"In Process",
            "enAbv":"In Process",
        }
    },
    {
        "Sort_Type": "Success",
        "Class_Name": "Success",
        "Name_Display":
        {
            "id":"Berhasil",
            "idAbv":"Berhasil",
            "en":"Success",
            "enAbv":"Success",
        }
    }
]
window.ListOfFilterPinginGoVoucher = ["All", "Available", "Used", "Expired"];
window.ListOfFilterVoucherPartner = ["All", "In Process", "Success"];
window.ListOfFilterGiftReward = ["All", "In Process", "Success"];

// Elements -------------------------------
var RewardSelectedDropDownContainer;
var RewardSelectedDropDownText;

var TopReferralSectionButton;

var PinginGoVoucherFilterButton;
var VoucherPartnerFilterButton;
var GiftRewardFilterButton;

var SelectedSortOrangeWrapper;

var LoadMoreRewardButton;

var RewardGridContainer;

var NoVoucherFoundContainer;
var NoVoucherFoundHeaderText;
var NoVoucherFoundMessageText;

// ================================= PREPARE ELEMENT =================================

window.PrepareRewardMenuElements = function()
{
    let WhichPageSectionIsText = document.getElementById("WhichPageSectionIsText");
    WhichPageSectionIsText.innerHTML = window["MyVoucherTxt" + window.CurrentCountryID];

    let TopReferralSectionButton = document.querySelectorAll('.TopReferralSectionButton');
    for(let i = 0; i < TopReferralSectionButton.length; i++)
    {
        for(let j = 0; j < ListOfTopSortType.length; j++)
        {
            if(TopReferralSectionButton[i].id == (ListOfTopSortType[j].What_Type + "FilterButton"))
            {
                TopReferralSectionButton[i].querySelector('p').innerHTML = ListOfTopSortType[j].Name_Display[window.CurrentCountryID];
            }
        }
    }
    document.getElementById("LoadMoreRewardButton").style.display = "none";
    document.getElementById("LoadMoreRewardButton").innerHTML = window["LoadMoreTxt" + window.CurrentCountryID];

    document.getElementById("NoVoucherFoundHeaderText").innerHTML = window["OopsNoVoucherTxt" + window.CurrentCountryID];
}

window.AssignFunctionVariableRewardMenu = function(mainsession, loggedin)
{
    RewardSelectedDropDownContainer = document.getElementById("RewardSelectedDropDownContainer");
    RewardSelectedDropDownContainer.onclick = function()
    {
        OpenDropDownRewardType(RewardSelectedDropDownContainer, mainsession, loggedin);
    }

    RewardSelectedDropDownText = document.getElementById("RewardSelectedDropDownText");

    TopReferralSectionButton = document.querySelectorAll('.TopReferralSectionButton');
    for(let i = 0; i < TopReferralSectionButton.length; i++)
    {
        for(let j = 0; j < ListOfTopSortType.length; j++)
        {
            if(TopReferralSectionButton[i].id == (ListOfTopSortType[j].What_Type + "FilterButton"))
            {
                TopReferralSectionButton[i].querySelector('p').innerHTML = ListOfTopSortType[j].Name_Display[window.CurrentCountryID];
            }
        }
    }

    PinginGoVoucherFilterButton = document.getElementById("PinginGoVoucherFilterButton");
    PinginGoVoucherFilterButton.onclick = function()
    {
        SelectedArray = "PinginGoVoucher";
        ApplyRewardTypeChanges(mainsession, loggedin);
    }
    VoucherPartnerFilterButton = document.getElementById("VoucherPartnerFilterButton");
    VoucherPartnerFilterButton.onclick = function()
    {
        SelectedArray = "VoucherPartner";
        ApplyRewardTypeChanges(mainsession, loggedin);
    }
    GiftRewardFilterButton = document.getElementById("GiftRewardFilterButton");
    GiftRewardFilterButton.onclick = function()
    {
        SelectedArray = "GiftReward";
        ApplyRewardTypeChanges(mainsession, loggedin);
    }

    SelectedSortOrangeWrapper = document.getElementById("SelectedSortOrangeWrapper");

    LoadMoreRewardButton = document.getElementById("LoadMoreRewardButton");
    LoadMoreRewardButton.onclick = function()
    {
        CurrentVoucherIndex++;
        GetRewardList(mainsession, loggedin);
    }

    RewardGridContainer = document.getElementById("RewardGridContainer");

    NoVoucherFoundContainer = document.getElementById("NoVoucherFoundContainer");
    NoVoucherFoundHeaderText = document.getElementById("NoVoucherFoundHeaderText");

    NoVoucherFoundMessageText = document.getElementById("NoVoucherFoundMessageText");

    ApplyRewardTypeChanges(mainsession, loggedin);
}

// ================================= APPLY VOUCHER TYPE ===============================

function OpenDropDownRewardType(thiscontainer, mainsession, loggedin)
{
    window.event.preventDefault();
    window.event.stopPropagation();

    window.RotateToggle("RewardSelectedDropDownChevron", true);
        

    let ThisDropDownContainer = window.FunctionCheckInstantiateDropDown("RewardTypeDropDown", thiscontainer);

    if(ThisDropDownContainer == null)
        return

    ThisDropDownContainer.style.bottom = 0;
    ThisDropDownContainer.className = "ContainerFlex";
    ThisDropDownContainer.innerHTML = "";

    let DropDownContainer = document.createElement("div");
    DropDownContainer.className = "DropDownContainer HideScrollBar";
    ThisDropDownContainer.append(DropDownContainer);

    let ScrollToDropDown;

    for(let i = 0; i < ListOfTopSortType.length; i++)
    {
        let DropDownSelectionContainer = document.createElement("button");
        DropDownSelectionContainer.className = "DropDownSelectionContainer DropDownWithStatus";
        DropDownSelectionContainer.onclick = function(event)
        {
            event.preventDefault();
            event.stopPropagation();

            window.RotateToggle("", true);

            ThisDropDownContainer.remove();

            SelectedArray = ListOfTopSortType[i].What_Type;
                
            ApplyRewardTypeChanges(mainsession, loggedin);
        }
        DropDownContainer.append(DropDownSelectionContainer);
        
        let DropDownSelectionText = document.createElement("p");
        DropDownSelectionText.className = "DropDownSelectionText";
        DropDownSelectionText.innerHTML = ListOfTopSortType[i].Name_Display[window.CurrentCountryID];
        DropDownSelectionContainer.append(DropDownSelectionText);

        // Get Information For Basic Scroll Start
        if(SelectedArray == ListOfTopSortType[i].What_Type)
        {
            ScrollToDropDown = DropDownSelectionContainer;
            DropDownSelectionContainer.classList.add("DropDownSelectionContainerSelected");
        }
    }

    window.ScrollToSelectedDropDown(DropDownContainer, ScrollToDropDown)
}


function ApplyRewardTypeChanges(mainsession, loggedin)
{
    CurrentFunctionURL = "/vouchers/in-app";
    SelectedIDVoucherType = 1;

    for(let i = 0; i < ListOfTopSortType.length; i++)
    {
        if(ListOfTopSortType[i].What_Type == SelectedArray)
        {
            RewardSelectedDropDownText.innerHTML = ListOfTopSortType[i].Name_Display[window.CurrentCountryID];
            SelectedIDVoucherType = i+1;
            CurrentFunctionURL = ListOfTopSortType[i].Function_Name;
            NoVoucherFoundMessageText.innerHTML = window["NoVoucherMessageTxt" + window.CurrentCountryID](ListOfTopSortType[i].Name_Display[window.CurrentCountryID]);

            for(let j = 0; j < TopReferralSectionButton.length; j++)
            {
                if(TopReferralSectionButton[j].id == (SelectedArray + "FilterButton"))
                {
                    TopReferralSectionButton[j].className = "TopReferralSectionButton BasicRoundRadius BasicBoxShadowUp Selectable2 TopReferralSectionSelected";
                    SelectedSortOrangeWrapper.style.left = ((33.33 * j) + "%");
                }
                else
                {
                    TopReferralSectionButton[j].className = "TopReferralSectionButton BasicRoundRadius BasicBoxShadowUp Selectable2";
                }
            }
        }
    }
    InstantiateFilter2Buttons(mainsession, loggedin);
    
}

function InstantiateFilter2Buttons(mainsession, loggedin)
{
    let Filter2Buttons = document.querySelectorAll('.Filter2Buttons');
    Filter2Buttons.forEach(ThisButton =>
    {
        ThisButton.remove();
    });

    let WhereToInstantiate = document.getElementById("Filter2ButtonContainer");
    let FilterListToInst = window["ListOfFilter" + SelectedArray];

    for(let i = 0; i < FilterListToInst.length; i++)
    {
        for(let j = 0; j < ListOfStatusFilter.length; j++)
        {
            if(ListOfStatusFilter[j].Sort_Type == FilterListToInst[i])
            {
                let MainFilterButton = document.createElement("button");
                MainFilterButton.className = "BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable Filter2Buttons";
                MainFilterButton.id = ListOfStatusFilter[j].Class_Name + "Filter2Buttons";
                MainFilterButton.onclick = function()
                {
                    CurrentStatusSort = ListOfStatusFilter[j].Sort_Type;
                    OnChangeSortStatus(mainsession, loggedin);
                }
                WhereToInstantiate.append(MainFilterButton);

                let LengthyBtnTxt = document.createElement("p");
                LengthyBtnTxt.className = "LengthyBtnTxt";
                LengthyBtnTxt.innerHTML = ListOfStatusFilter[j].Name_Display[window.CurrentCountryID];
                MainFilterButton.append(LengthyBtnTxt);

                let ShortenedBtnTxt = document.createElement("p");
                ShortenedBtnTxt.className = "ShortenedBtnTxt";
                ShortenedBtnTxt.innerHTML = ListOfStatusFilter[j].Name_Display[window.CurrentCountryID+"Abv"];
                MainFilterButton.append(ShortenedBtnTxt);
            }
        }
    }
    CurrentStatusSort = "All";
    OnChangeSortStatus(mainsession, loggedin);
}

function OnChangeSortStatus(mainsession, loggedin)
{
    let Filter2Buttons = document.querySelectorAll('.Filter2Buttons');

    for(let i = 0; i < ListOfStatusFilter.length; i++)
    {
        if(ListOfStatusFilter[i].Sort_Type == CurrentStatusSort)
        {
            for(let j = 0; j < Filter2Buttons.length; j++)
            {
                if(Filter2Buttons[j].id == (ListOfStatusFilter[i].Class_Name + "Filter2Buttons"))
                {
                    Filter2Buttons[j].className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable Filter2Buttons";
                }
                else
                {
                    Filter2Buttons[j].className = "BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable Filter2Buttons";
                }
            }
        }

    }

    RewardGridContainer.innerHTML = "";
    CurrentVoucherIndex = 1;
    MaximumPageVoucher = 0;
    GetRewardList(mainsession, loggedin);
}

// ================================= LOAD REWARD LIST =================================

function GetRewardList(mainsession, loggedin)
{
    if(loggedin == true)
    {
        // -------------------------------------------------------------------

        let ThisVoucherLoadURL = "/access" + CurrentFunctionURL + "?id_user=" +  mainsession.usd_PING_id + "&page=" + CurrentVoucherIndex +  "&limit=" + MaximumRewardToInstantiate + "&filter=" + CurrentStatusSort + "&lang=" + window.CurrentCountryID;

        let RewardBlocker = window.InstantiateLoadingBlocker("RewardBlocker");

        // Reset Available Voucher and Put Loading ----------------------------
        
        let LoadingEarlyPanel = [];

        for(let i = 0; i < MaximumRewardToInstantiate; i++)
        {
            LoadingEarlyPanel.push(InstantiateLoadingWrapper(RewardGridContainer));
        }

        // Start Loadin Voucher -----------------------------------------------

        window.CallApiAxios({
            method: "GET",
            url: ThisVoucherLoadURL,
        }).then(res =>
        {
            RewardListData = res.data.data;
            MaximumPageVoucher = res.data.pagination.total_pages;
            
            //console.log(ThisVoucherLoadURL);
            //console.log(res.data);
            //console.log(RewardListData);

            LoadingEarlyPanel.forEach(panel => {
                panel.remove();
            });

            RewardBlocker.remove();
            SortRewardData(mainsession, loggedin);
        })
        .catch(err =>
        {
            //console.error(err);
            RewardBlocker.remove();
        });
    }
}

function SortRewardData(mainsession, loggedin)
{
    if(MaximumPageVoucher > 0)
    {
        RewardGridContainer.style.display = "";
        LoadMoreRewardButton.style.display = "none";
        NoVoucherFoundContainer.style.display = "none";
        InstantiateRewards(mainsession, loggedin);
    }
    else
    {
        RewardGridContainer.style.display = "none";
        LoadMoreRewardButton.style.display = "none";
        NoVoucherFoundContainer.style.display = "";
    }
}

function InstantiateRewards(mainsession, loggedin)
{
    for(let i = 0; i < RewardListData.length; i++)
    {
        let LoadingRewardContainer = InstantiateLoadingWrapper(RewardGridContainer);

        let VoucherMainPanel = document.createElement("div");
        VoucherMainPanel.className = "VoucherMainPanel BasicBoxShadowMid BasicRoundRadius SpecialHovSelectable";
        VoucherMainPanel.style.display = "none";
        RewardGridContainer.append(VoucherMainPanel);

        let TopRewardSection = document.createElement("div");
        TopRewardSection.className = "TopRewardSection TargetSpecialHovSelect";
        VoucherMainPanel.append(TopRewardSection);

        // Images -------------------------------------------------------------------------

        let VoucherImageContainer = document.createElement("div");
        VoucherImageContainer.className = "VoucherImageContainer";
        TopRewardSection.append(VoucherImageContainer);

        let StatusDisplay = RewardListData[i].status_voucher;
        if(RewardListData[i].status != null)
            StatusDisplay = RewardListData[i].status;

        let VoucherStockText = document.createElement("p");
        VoucherStockText.className = "SmallRoundedText InterMediumTextFont VoucherStatus" + StatusDisplay.replace(/\s/g, '');
        VoucherStockText.style.color = "#ffffff";
        VoucherStockText.textContent = StatusDisplay;
        VoucherImageContainer.append(VoucherStockText);

        let VoucherImage = document.createElement("img");
        VoucherImage.className = "ImageFullCover";
        if(RewardListData[i].image_link == null || RewardListData[i].image_link == "")
        {
            VoucherImage.src = "/Assets/images/NoHotelImage.jpg";
        }
        else
        {
            VoucherImage.src = RewardListData[i].image_link;
        }
        VoucherImageContainer.append(VoucherImage);

        // Info -------------------------------------------------------------------------

        let VoucherInfoWrapper = document.createElement("div");
        VoucherInfoWrapper.className = "VoucherInfoWrapper";
        TopRewardSection.append(VoucherInfoWrapper);

        let InfoTitleWrapper = document.createElement("div");
        InfoTitleWrapper.className = "BasicChildMargin2 InputFieldMargin3";
        InfoTitleWrapper.style.display = "flex";
        VoucherInfoWrapper.append(InfoTitleWrapper);

        let InfoTitle = document.createElement("p");
        InfoTitle.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont";
        InfoTitle.textContent = RewardListData[i].voucher_name;
        InfoTitleWrapper.append(InfoTitle);

        // REWARD INFO ======================================
        let RewardInfoSeparatorWrapper = document.createElement("div");
        RewardInfoSeparatorWrapper.className = "RewardInfoSeparatorWrapper";
        VoucherInfoWrapper.append(RewardInfoSeparatorWrapper);

        //----------------------------- EXPIRY DATE/ CLAIM DATE -----------------------------------

        let PoinWithIconWrapper1 = document.createElement("div");
        PoinWithIconWrapper1.className = "PoinWithIconWrapper PoinWithIconWrapperVoucherMenu BasicChildMargin2 InputFieldMargin4";
        RewardInfoSeparatorWrapper.append(PoinWithIconWrapper1);

        let ClockIcon = document.createElement("img");
        ClockIcon.src = "/Assets/images/ButtonIcon/clock-icon-orange.svg";
        ClockIcon.style.marginLeft = "0";
        PoinWithIconWrapper1.append(ClockIcon);

        let RewardInfoSmallWrapper1 = document.createElement("div");
        RewardInfoSmallWrapper1.className = "RewardInfoSmallWrapper";
        PoinWithIconWrapper1.append(RewardInfoSmallWrapper1);

        let ExpiredDateLabel = document.createElement("p");
        ExpiredDateLabel.className = "SmallerRoomDescriptionText InterRegularTextFont";
        ExpiredDateLabel.style.color = "#797979";

        RewardInfoSmallWrapper1.append(ExpiredDateLabel);

        let ExpiredDateText = document.createElement("p");
        ExpiredDateText.className = "SmallerRoomDescriptionText InterRegularTextFont";
        ExpiredDateText.style.marginLeft = "auto";
        RewardInfoSmallWrapper1.append(ExpiredDateText);

        if(SelectedArray == "PinginGoVoucher" || SelectedArray == "VoucherPartner")
        {
            ExpiredDateLabel.textContent = window["BerlakuSDTxt" + window.CurrentCountryID];

            let ThisStartDate = RewardListData[i].valid_from;
            if(RewardListData[i].start_date != null)
                ThisStartDate = RewardListData[i].start_date;

            let ThisEndDate = RewardListData[i].valid_until;
            if(RewardListData[i].end_date != null)
                ThisEndDate = RewardListData[i].end_date;

            if(ThisEndDate != null && ThisEndDate != "")
            {
                let ThisVoucherStartDateArray = ThisStartDate.split("-");
                let VoucherStartYear = ThisVoucherStartDateArray[0];
                let VoucherStartMonth = ThisVoucherStartDateArray[1];
                let VoucherStartDate = ThisVoucherStartDateArray[2];

                let ThisVoucherDeadlineArray = ThisEndDate.split("-");
                let VoucherEndYear = ThisVoucherDeadlineArray[0];
                let VoucherEndMonth = ThisVoucherDeadlineArray[1];
                let VoucherEndDate = ThisVoucherDeadlineArray[2];

                ExpiredDateText.innerHTML = VoucherStartDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherStartMonth) - 1] + " " + VoucherStartYear + " - " + VoucherEndDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherEndMonth) - 1] + " " + VoucherEndYear;
                }
            else
            {
                ExpiredDateText.innerHTML = window["NoExpDateTxt" + window.CurrentCountryID];
            }
        }
        else // IF Gift, then Claim Date
        {
            ExpiredDateLabel.textContent = window["ClaimDateTxt" + window.CurrentCountryID];
            
            if(RewardListData[i].claimed_date != null && RewardListData[i].claimed_date != "")
            {
                let ThisVoucherClaimedDateTimeArray = RewardListData[i].claimed_date.split(' ');
                let ThisVoucherClaimedDateArray = ThisVoucherClaimedDateTimeArray[0].split('-');
                let VoucherClaimedYear = ThisVoucherClaimedDateArray[0];
                let VoucherClaimedMonth = ThisVoucherClaimedDateArray[1];
                let VoucherClaimedDate = ThisVoucherClaimedDateArray[2];

                let ThisVoucherClaimedTimeArray = ThisVoucherClaimedDateTimeArray[1].split(':');
                let VoucherClaimedHour = ThisVoucherClaimedTimeArray[0];
                let VoucherClaimedMin = ThisVoucherClaimedTimeArray[1];

                ExpiredDateText.innerHTML = VoucherClaimedDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherClaimedMonth)-1] + " " + VoucherClaimedYear + ", " + VoucherClaimedHour + ":" + VoucherClaimedMin;
            }
            else
            {
                ExpiredDateText.innerHTML = window["NoClaimDateTxt" + window.CurrentCountryID];
            }
        }

        //----------------------------- Minimum Transaction -----------------------------------

        let PoinWithIconWrapper2 = document.createElement("div");
        PoinWithIconWrapper2.className = "PoinWithIconWrapper PoinWithIconWrapperVoucherMenu BasicChildMargin2 InputFieldMargin4";
        RewardInfoSeparatorWrapper.append(PoinWithIconWrapper2);

        let RpIcon = document.createElement("img");
        RpIcon.src = "/Assets/images/ButtonIcon/RP-icon.svg";
        RpIcon.style.marginLeft = "0";
        PoinWithIconWrapper2.append(RpIcon);

        let RewardInfoSmallWrapper2 = document.createElement("div");
        RewardInfoSmallWrapper2.className = "RewardInfoSmallWrapper";
        PoinWithIconWrapper2.append(RewardInfoSmallWrapper2);

        let RewardMinLabel = document.createElement("p");
        RewardMinLabel.className = "SmallerRoomDescriptionText InterRegularTextFont";
        RewardMinLabel.style.color = "#797979";
        RewardInfoSmallWrapper2.append(RewardMinLabel);

        let RewardMinValue = document.createElement("p");
        RewardMinValue.className = "SmallerRoomDescriptionText InterRegularTextFont";
        RewardMinValue.style.marginLeft = "auto";
        RewardInfoSmallWrapper2.append(RewardMinValue);

        if(SelectedArray == "PinginGoVoucher" || SelectedArray == "VoucherPartner") // Min Transaction
        {
            RewardMinLabel.textContent = window["MinTransaksiTxt" + window.CurrentCountryID];

            if(RewardListData[i].min_transaction != null && RewardListData[i].min_transaction != "" && RewardListData[i].min_transaction != 0)
            {
                RewardMinValue.innerHTML = window.ConvertTextToRP(RewardListData[i].min_transaction, 1, true);
            }
            else
            {
                RewardMinValue.innerHTML = window["NoMinimum2Txt" + window.CurrentCountryID];
            }
        }
        else // If Gift, then Poin Deducted
        {
            RewardMinLabel.textContent = window["PoinDeductedTxt" + window.CurrentCountryID];

            if(RewardListData[i].poin_deducted != null && RewardListData[i].poin_deducted != "")
            {
                let PoinDeductedArray = RewardListData[i].poin_deducted.split(" ");
                RewardMinValue.innerHTML = PoinDeductedArray[0] + " " + PoinDeductedArray[1] + " " + window["PointsTxt" + window.CurrentCountryID];
            }
            else
            {
                RewardMinValue.innerHTML = window["NoPoinDeductedTxt" + window.CurrentCountryID];
            }
        }

        //----------------------------- Minimum Transaction -----------------------------------

        if(SelectedArray == "PinginGoVoucher")
        {
            let KodeVoucherWrapper = document.createElement("div");
            KodeVoucherWrapper.className = "KodeVoucherWrapper";
            VoucherMainPanel.append(KodeVoucherWrapper);

            let KodeLabel = document.createElement("p");
            KodeLabel.className = "SmallerRoomDescriptionText InterMediumTextFont";
            KodeLabel.style.color = "#797979";
            KodeLabel.textContent = window["VoucherCodeTxt" + window.CurrentCountryID];
            KodeVoucherWrapper.append(KodeLabel);

            let CopyCodeContainer = document.createElement("div");
            CopyCodeContainer.className = "CopyCodeContainer";
            KodeVoucherWrapper.append(CopyCodeContainer);

            let CopyText = document.createElement("p");
            CopyText.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText";
            CopyText.style.color = "rgb(29, 41, 57)";
            CopyText.innerHTML = RewardListData[i].voucher_code + " ";
            CopyCodeContainer.append(CopyText);

            let CopyIcon = document.createElement("img");
            CopyIcon.className =  "Selectable2 CopyRewardIcon";
            CopyIcon.src = "/Assets/images/ButtonIcon/orange-copy-icon.svg";
            CopyIcon.onclick = function()
            {
                window.event.preventDefault();
                window.event.stopPropagation();
                window.CopyToClipboardItem(RewardListData[i].voucher_code);
            }
            CopyText.append(CopyIcon);

            let CopyButton = document.createElement("button");
            CopyButton.className = "BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable";
            CopyButton.onclick = function()
            {
                window.event.preventDefault();
                window.event.stopPropagation();
                window.CopyToClipboardItem(RewardListData[i].voucher_code);
            }
            CopyCodeContainer.append(CopyButton);

            let CopyButtonInner = document.createElement("div");
            CopyButtonInner.style.width = "fit-content";
            CopyButtonInner.style.height = "fit-content";
            CopyButtonInner.style.display = "flex";
            CopyButtonInner.style.margin = "auto";
            CopyButtonInner.style.opacity = "1";
            CopyButton.append(CopyButtonInner);

            let CopyButtonIcon = document.createElement("img");
            CopyButtonIcon.src = "/Assets/images/ButtonIcon/copy-white-icon.svg";
            CopyButtonIcon.className = "BasicIconInsideButton2";
            CopyButtonIcon.style.marginLeft = "0";
            CopyButtonInner.append(CopyButtonIcon);

            let CopyButtonText = document.createElement("p");
            CopyButtonText.id = "TukarPointButtonText";
            CopyButtonText.textContent = window["CopyTxt" + window.CurrentCountryID];
            CopyButtonInner.append(CopyButtonText);
        }

        let VoucherDetailsHREF = document.createElement("a");
        VoucherDetailsHREF.className = "HREFInsideContainer";
        VoucherDetailsHREF.href = "/voucherdetails/" + window.CurrentCountryID +"?id_voucher=" + RewardListData[i].id_voucher + "&reward_type=" + SelectedIDVoucherType;
        TopRewardSection.append(VoucherDetailsHREF);

        window.HandleAllImageLoadWithFunction(VoucherMainPanel.querySelectorAll('img'), function()
        {
            LoadingRewardContainer.remove();
            VoucherMainPanel.style.display = "";
        });
    }

    if(CurrentVoucherIndex >= MaximumPageVoucher)
    {
        LoadMoreRewardButton.style.display = "none";
    }
    else
    {
        LoadMoreRewardButton.style.display = "";
    }
}

function InstantiateLoadingWrapper(WhereToInstantiate)
{
    let VoucherMainPanel = document.createElement("div");
    VoucherMainPanel.className = "VoucherMainPanel BasicBoxShadow BasicRoundRadius";
    WhereToInstantiate.append(VoucherMainPanel);

    let TopRewardSection = document.createElement("div");
    TopRewardSection.className = "TopRewardSection";
    VoucherMainPanel.appendChild(TopRewardSection);

    let VoucherImageContainer = document.createElement("div");
    VoucherImageContainer.className = "VoucherImageContainer loading_grey";
    TopRewardSection.appendChild(VoucherImageContainer);

    let VoucherInfoWrapper = document.createElement("div");
    VoucherInfoWrapper.className = "VoucherInfoWrapper";
    TopRewardSection.appendChild(VoucherInfoWrapper);

    let InfoTitleWrapper = document.createElement("div");
    InfoTitleWrapper.className = "BasicChildMargin2 InputFieldMargin3";
    InfoTitleWrapper.style.display = "flex";
    VoucherInfoWrapper.appendChild(InfoTitleWrapper);

    let InfoTitle = document.createElement("p");
    InfoTitle.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont loading_grey";
    InfoTitle.style.color = "transparent";
    InfoTitle.textContent = "Discount Referral 100rb";
    InfoTitleWrapper.appendChild(InfoTitle);

    let RewardInfoSeparatorWrapper = document.createElement("div");
    RewardInfoSeparatorWrapper.className = "RewardInfoSeparatorWrapper";
    VoucherInfoWrapper.appendChild(RewardInfoSeparatorWrapper);

    let PoinWithIconWrapper1 = document.createElement("div");
    PoinWithIconWrapper1.className = "PoinWithIconWrapper PoinWithIconWrapperVoucherMenu BasicChildMargin2 InputFieldMargin4";
    RewardInfoSeparatorWrapper.appendChild(PoinWithIconWrapper1);

    let RewardInfoSmallWrapper1 = document.createElement("div");
    RewardInfoSmallWrapper1.className = "RewardInfoSmallWrapper";
    PoinWithIconWrapper1.appendChild(RewardInfoSmallWrapper1);

    let RewardDateLabel = document.createElement("p");
    RewardDateLabel.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    RewardDateLabel.style.color = "transparent";
    RewardDateLabel.style.width = "fit-content";
    RewardDateLabel.textContent = "Berlaku s/d";
    RewardInfoSmallWrapper1.appendChild(RewardDateLabel);

    let RewardDateValue = document.createElement("p");
    RewardDateValue.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    RewardDateValue.style.marginLeft = "auto";
    RewardDateValue.style.color = "transparent";
    RewardDateValue.style.width = "fit-content";
    RewardDateValue.textContent = "1 Oct 2024 - 30 Dec 2024";
    RewardInfoSmallWrapper1.appendChild(RewardDateValue);

    let PoinWithIconWrapper2 = document.createElement("div");
    PoinWithIconWrapper2.className = "PoinWithIconWrapper PoinWithIconWrapperVoucherMenu BasicChildMargin2 InputFieldMargin4";
    RewardInfoSeparatorWrapper.appendChild(PoinWithIconWrapper2);

    let RewardInfoSmallWrapper2 = document.createElement("div");
    RewardInfoSmallWrapper2.className = "RewardInfoSmallWrapper";
    PoinWithIconWrapper2.appendChild(RewardInfoSmallWrapper2);

    let RewardMinLabel = document.createElement("p");
    RewardMinLabel.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    RewardMinLabel.style.color = "transparent";
    RewardMinLabel.style.width = "fit-content";
    RewardMinLabel.textContent = "Min. Transaksi";
    RewardInfoSmallWrapper2.appendChild(RewardMinLabel);

    let RewardMinValue = document.createElement("p");
    RewardMinValue.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    RewardMinValue.style.marginLeft = "auto";
    RewardMinValue.style.color = "transparent";
    RewardMinValue.style.width = "fit-content";
    RewardMinValue.textContent = "Tidak ada Minimum";
    RewardInfoSmallWrapper2.appendChild(RewardMinValue);

    if(SelectedArray == "PinginGoVoucher")
    {
        let KodeVoucherWrapper = document.createElement("div");
        KodeVoucherWrapper.className = "KodeVoucherWrapper";
        VoucherMainPanel.appendChild(KodeVoucherWrapper);

        let KodeLabel = document.createElement("p");
        KodeLabel.className = "SmallerRoomDescriptionText InterMediumTextFont loading_grey";
        KodeLabel.style.color = "transparent";
        KodeLabel.style.width = "fit-content";
        KodeLabel.textContent = "Kode Voucher";
        KodeVoucherWrapper.appendChild(KodeLabel);

        let CopyCodeContainer = document.createElement("div");
        CopyCodeContainer.className = "CopyCodeContainer loading_grey";
        KodeVoucherWrapper.appendChild(CopyCodeContainer);

        let CopyText = document.createElement("p");
        CopyText.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText";
        CopyText.style.color = "transparent";
        CopyText.innerHTML = `Test1234 <img class="Selectable2 CopyRewardIcon" src="/Assets/images/ButtonIcon/orange-copy-icon.svg" style="opacity:0;">`;
        CopyCodeContainer.appendChild(CopyText);

        let CopyButton = document.createElement("button");
        CopyButton.className = "BasicTextButton BasicBoxShadow BlueButton SignInButtonTop Selectable";
        CopyButton.style.opacity = 0;
        CopyCodeContainer.appendChild(CopyButton);

        let CopyButtonInner = document.createElement("div");
        CopyButtonInner.style.width = "fit-content";
        CopyButtonInner.style.height = "fit-content";
        CopyButtonInner.style.display = "flex";
        CopyButtonInner.style.margin = "auto";
        CopyButtonInner.style.opacity = "0";
        CopyButton.appendChild(CopyButtonInner);

        let CopyButtonIcon = document.createElement("img");
        CopyButtonIcon.src = "/Assets/images/ButtonIcon/copy-white-icon.svg";
        CopyButtonIcon.className = "BasicIconInsideButton2";
        CopyButtonIcon.style.marginLeft = "0";
        CopyButtonInner.appendChild(CopyButtonIcon);

        let CopyButtonText = document.createElement("p");
        CopyButtonText.id = "TukarPointButtonText";
        CopyButtonText.textContent = "Copy";
        CopyButtonInner.appendChild(CopyButtonText);
    }

    return VoucherMainPanel;
}